import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import apiClient, { API_ENDPOINTS } from '../../config/api'

const AddBranch = () => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    phone: '',
    warehouse: ''
  })
  const [warehouses, setWarehouses] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingWarehouses, setLoadingWarehouses] = useState(false)

  useEffect(() => {
    fetchWarehouses()
  }, [])

  const fetchWarehouses = async () => {
    setLoadingWarehouses(true)
    try {
      const response = await apiClient.get(API_ENDPOINTS.WAREHOUSES)
      setWarehouses(response.data.results || response.data || [])
    } catch (error) {
      console.error('Error fetching warehouses:', error)
      setWarehouses([])
    } finally {
      setLoadingWarehouses(false)
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const warehouseRaw = formData.warehouse
      const warehouseParsed =
        warehouseRaw === '' || warehouseRaw == null
          ? null
          : parseInt(warehouseRaw, 10)
      const payload = {
        name: formData.name.trim(),
        address: (formData.address || '').trim(),
        phone: (formData.phone || '').trim(),
        warehouse: Number.isNaN(warehouseParsed) ? null : warehouseParsed
      }

      await apiClient.post(API_ENDPOINTS.BRANCHES, payload)

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Branch created successfully!',
        confirmButtonText: 'OK'
      })

      // Reset form
      setFormData({
        name: '',
        address: '',
        phone: '',
        warehouse: ''
      })
    } catch (error) {
      console.error('Error creating branch:', error)
      const errorMessage = error.response?.data?.name?.[0] ||
                          error.response?.data?.warehouse?.[0] ||
                          error.response?.data?.phone?.[0] ||
                          error.response?.data?.address?.[0] ||
                          error.response?.data?.non_field_errors?.[0] ||
                          error.response?.data?.detail ||
                          error.response?.data?.message ||
                          'Failed to create branch. Please try again.'
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Add Branch</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item">Branches</li>
            <li className="breadcrumb-item active">Add Branch</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-shop me-2"></i>
                  Create New Branch
                </h5>

                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <label htmlFor="warehouse" className="col-sm-2 col-form-label">Warehouse</label>
                    <div className="col-sm-10">
                      <select
                        className="form-select"
                        id="warehouse"
                        name="warehouse"
                        value={formData.warehouse}
                        onChange={handleChange}
                        disabled={loadingWarehouses}
                      >
                        <option value="">{loadingWarehouses ? 'Loading warehouses...' : 'None (optional)'}</option>
                        {warehouses.map(warehouse => (
                          <option key={warehouse.id} value={warehouse.id}>
                            {warehouse.name || `Warehouse ${warehouse.id}`}
                          </option>
                        ))}
                      </select>
                      {warehouses.length === 0 && !loadingWarehouses && (
                        <small className="text-muted">No warehouses available. Please add warehouses first.</small>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="name" className="col-sm-2 col-form-label">Branch Name <span className="text-danger">*</span></label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter branch name"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="address" className="col-sm-2 col-form-label">Address</label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control"
                        id="address"
                        name="address"
                        rows="3"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Enter branch address"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="phone" className="col-sm-2 col-form-label">Phone</label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        maxLength={20}
                        placeholder="Contact phone (optional)"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm-10 offset-sm-2">
                      <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-plus-circle me-2"></i>
                            Create Branch
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AddBranch

